import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Images } from "../../../assets";
import { CreateCampaignDripDto } from "../../../model/campaign/dto/CreateCampaignDripDto";
import capitalize from "lodash/capitalize";
import { useTheme } from "../../../ThemeContext";
import { Text } from "../../../components/Text";
import { Flex } from "../../../components/Flex";
import { AtiraIcon } from "../../../components/AtiraIcon";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { Rounded } from "../../../theme/Rounded";
import { Spacing } from "../../../theme/Spacing";

const StyledTable = styled.table`
  border-radius: 8px;
  background-color: #fff;
  font-family: Arial, sans-serif;
  border-radius: 8px;
  max-width: 30rem;
  width: 100%;

  * {
    padding: revert;
    margin: revert;
  }
`;

const LogoColumn = styled.td`
  background-color: #ebebeb;
  border-radius: 8px 8px 0 0;
  padding: 24px 16px 16px 16px;
`;

const Logo = styled.img`
  max-width: 220px;
  margin-bottom: 8px;
`;

const ContentColumn = styled.td`
  padding: 0 32px;
`;

const Title = styled.h1`
  color: #803588;
  text-align: center;
  padding: 16px 0;
  font-size: 24px;
`;

const Paragraph = styled.p`
  text-align: center;
  line-height: 20px;
  color: #222;
  font-size: 14px;
`;

const Link = styled.a`
  display: inline-block;
  text-align: center;
  color: ${({ theme }) => theme.main};
  text-decoration: none;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
    text-decoration-color: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accent};
  }
`;

const Container = styled(Flex)`
  border: ${({ theme }) => `2px solid ${theme.darkerSub}`}55;
  align-items: center;
  width: 100%;
  padding: ${Spacing.m};
  border-radius: ${Rounded.lg};
  justify-content: center;
`;

type DripCampaignPreviewModalProps = {
  step?: CreateCampaignDripDto["steps"][number] | null;
};

export const DripCampaignPreview: React.FC<DripCampaignPreviewModalProps> = ({
  step,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "campaigns.dripCampaign.step.campaignSteps.step.preview.modal",
  });
  const { selectedTheme } = useTheme();

  return (
    <Flex flexDirection="column" gap="s" width="100%">
      <Flex alignItems="center" gap="s">
        <AtiraIcon icon={faEye} />
        <Text fontWeight={"bold"}>{t("title")}</Text>
      </Flex>
      <Container>
        <StyledTable cellPadding="0" cellSpacing="0" align="center">
          <tr>
            <LogoColumn align="center">
              <Logo
                src={
                  Images[
                    `AtiraSpaceLogoBeta${capitalize(selectedTheme)}` as keyof typeof Images
                  ]
                }
              />
            </LogoColumn>
          </tr>

          <tr>
            <ContentColumn>
              <Title>
                {step?.subject || t("defaultTitle", { step: step?.stepNumber })}
              </Title>
              <Paragraph>
                {step?.body || t("defaultBody", { step: step?.stepNumber })}
              </Paragraph>
            </ContentColumn>
          </tr>

          {step?.ctaUrl || step?.ctaText ? (
            <tr>
              <ContentColumn>
                <Flex gap="s" justifyContent="center" alignItems="center">
                  {/* {step?.ctaIcon ? (
                    <AtiraIcon
                      icon={getFontAwesomeIcon(step.ctaIcon as any)!}
                      color="main"
                    />
                  ) : null} */}
                  <Link
                    href={step.ctaUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {step?.ctaText ||
                      t("defaultCtaText", { step: step?.stepNumber })}
                  </Link>
                </Flex>
              </ContentColumn>
            </tr>
          ) : null}
        </StyledTable>
      </Container>
    </Flex>
  );
};
